<template>

<div>
    <h1>Articles Admin Home</h1>
    <h3>Generate PDFs</h3>
    <ul class="generate-pdfs">
        <li :class="{ disabled: saving == index }" v-for="(item, index) in getKBMenu">
            <span v-if="saving == index">Generate {{ item.category }} PDF</span>
            <span @click="printCategory(index, item)" v-else>Generate {{ item.category }} PDF</span>
            <a :href="'https://s3.us-east-2.amazonaws.com/media.connecteddatasolutions.com/downloads/' + item.category.dasherize() + '-' + item.kb_category_id + '-manual.pdf'" target="_blank">(link)</a>
            <i class="fas fa-spinner fa-spin" v-if="saving == index"></i>
        </li>
    </ul>
</div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'help-center-articles-list',
    props: [ 'id' ],
    data() {
        return {
            definition: [],
            articles: [],
            flatList: [],
            saving: null
        }
    },
    created() {
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getKBMenu'
        ])
    },
    methods: {
        printCategory(index, item) {
            if (this.saving) return
            this.saving = index
            this.flatList = [];
            this.flatList.push(item.kb_item_id)
            this.constructFlatListForCategory(item.sub_menu).then(() => {
                this.apiCall({ destination: 'generate_category_pdf', data: { ids: this.flatList, category_title: item.category, category_name: item.category.dasherize(), kb_category_id: item.kb_category_id } }).then(obj => {
                    this.saving = null
                    if (obj.pdf_url) {
                        window.open(obj.pdf_url)
                    } else {
                        alert('PDF not generated!\n' + obj.message)
                    }
                }).catch(err => {
                    this.saving = null
                    console.log(err);
                })
            })

        },
        constructFlatListForCategory(items) {
            return new Promise((resolve, reject) => {
                for (var i = 0; i < items.length; i++) {
                    this.flatList.push(items[i].kb_item_id)
                    if (items[i].sub_menu.length > 0) {
                        this.constructFlatListForCategory(items[i].sub_menu)
                    }
                }
                resolve()
            })
        }
    }
}
</script>

<style>

</style>
